import salesStageTypesActions from './actions';
import { SalesStageTypesState } from './types';
import { createSlice } from '@reduxjs/toolkit';

const initialState: SalesStageTypesState = {
  salesStageTypes: [],
  salesStageTypesError: null,
  salesStageTypesLoading: false,
  salesStageTypesIsEmpty: false,
};

export const salesStageTypesSlice = createSlice({
  initialState,
  name: 'salesStageTypes',
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(salesStageTypesActions.getSalesStageTypes.pending, (state) => {
      state.salesStageTypesLoading = true;
    });

    builder.addCase(salesStageTypesActions.getSalesStageTypes.fulfilled, (state, { payload: { salesStageTypes } }) => {
      state.salesStageTypesError = null;
      state.salesStageTypesLoading = false;
      state.salesStageTypes = salesStageTypes;
      state.salesStageTypesIsEmpty = !!!salesStageTypes.length;
    });

    builder.addCase(salesStageTypesActions.getSalesStageTypes.rejected, (state, { error }) => {
      state.salesStageTypesLoading = false;
      state.salesStageTypesError = error;
    });
  },
});

export default salesStageTypesSlice.reducer;
